import type { Club } from "@/lib/types";

export function altitudeMultiplier(altitudeFt: number): number {
  const a = Number.isFinite(altitudeFt) ? altitudeFt : 0;
  return 1 + (a / 1000) * 0.02;
}

export function adjustCarryForAltitude(carryYards: number, altitudeFt: number): number {
  return Math.round(carryYards * altitudeMultiplier(altitudeFt));
}

export function adjustBagForAltitude(bag: Club[], altitudeFt: number): Club[] {
  const mult = altitudeMultiplier(altitudeFt);
  return bag.map((club) => ({
    ...club,
    carryYards: Math.round(club.carryYards * mult),
  }));
}